import { clsx } from "clsx";
import Decimal from "decimal.js";
import { twMerge } from "tailwind-merge";

Decimal.set({ precision: 20 });

export const calcMultiply = (a = 0, b = 0, digits = 12) => {
  const x = new Decimal(a.toString());
  const y = new Decimal(b.toString());
  return x.times(y).toSignificantDigits(digits);
};

export const calcDivide = (a = 0, b = 0, digits = 12) => {
  const x = new Decimal(a.toString());
  const y = new Decimal(b.toString());
  return x.div(y).toSignificantDigits(digits);
};

export const cn = (...inputs) => {
  return twMerge(clsx(inputs));
};

export const getLabel = (options, key) =>
  options.find((option) => option.key === key)?.value || key;

export const ThousandSeparator = (value) => {
  if (!value) value = 0;
  if (typeof value === "number") {
    return parseFloat(value.toFixed(3)).toLocaleString(undefined, {
      minimumFractionDigits: 3,
      maximumFractionDigits: 3,
    });
  } else {
    return value?.toLocaleString();
  }
};
export const FourDecimalSeparator = (value) => {
  if (!value) value = 0;
  if (typeof value === "number") {
    return parseFloat(value.toFixed(4)).toLocaleString(undefined, {
      minimumFractionDigits: 4,
      maximumFractionDigits: 4,
    });
  } else {
    return value?.toLocaleString();
  }
};

export const ThreeDecimalSeparator = (value) => {
  if (!value) value = 0;
  if (typeof value === "number") {
    return parseFloat(value.toFixed(4)).toLocaleString(undefined, {
      minimumFractionDigits: 3,
      maximumFractionDigits: 3,
    });
  } else {
    return value?.toLocaleString();
  }
};

export const capFirstChr = (str) => {
  return str.charAt(0).toUpperCase() + str.slice(1);
};

export const checkInfinity = (number) => {
  return isFinite(number) ? number?.toFixed(3) : "N/A";
};

export function base64ToUint8Array(base64) {
  const binary = atob(base64);
  const len = binary.length;
  const bytes = new Uint8Array(len);
  for (let i = 0; i < len; i++) {
    bytes[i] = binary.charCodeAt(i);
  }
  return bytes;
}

export const pick = (obj, keys) =>
  Object.fromEntries(keys.map((key) => [key, obj[key]]));
